import locale from './locale';

export default [
  {
    label: __('First Name', locale),
    name: 'firstName',
    required: true,
    isImportField: true,
  },
  {
    label: __('Last Name', locale),
    name: 'lastName',
    required: true,
    isImportField: true,
  },
  {
    label: __('Name', locale),
    required: true,
    isSettingItem: true,
  },
  {
    label: __('Gender', locale),
    name: 'gender',
    // required: true,
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('DOB', locale),
    name: 'dob',
    // required: true,
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Country Code', locale),
    name: 'countryCode',
    //required: true,
    isImportField: true,
  },
  {
    label: __('Mobile Number', locale),
    name: 'phone',
    //required: true,
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Nickname', locale),
    name: 'nickName',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Email', locale),
    name: 'email',
    required: false,
    isImportField: true,
    isSettingItem: true,
  },


  {
    label: __('Current Address', locale),
    isSettingItem: true,
  },
  
  
  {
    label: __('Street', locale),
    name: 'address',
    isImportField: true,
  },
  {
    label: __('Unit No.', locale),
    name: 'suiteNumber',
    isImportField: true,
  },

  {
    label: __('City', locale),
    name: 'city',
    isImportField: true,
  },
  {
    label: __('Province/States', locale),
    name: 'province',
    isImportField: true,
  },
  {
    label: __('Country', locale),
    name: 'country',
    isImportField: true,
  },
  {
    label: __('Postal Code', locale),
    name: 'postalCode',
    isImportField: true,
  },


  {
    label: __('Remark', locale),
    name: 'remark',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Primary Guardian Name', locale),
    name: 'primaryGuardianName',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Primary Guardian Relationship', locale),
    name: 'primaryGuardianRelationship',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Primary Guardian Phone', locale),
    name: 'primaryGuardianPhone',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Primary Guardian Email', locale),
    name: 'primaryGuardianEmail',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Secondary Guardian Name', locale),
    name: 'secondaryGuardianName',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Secondary Guardian Relationship', locale),
    name: 'secondaryGuardianRelationship',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Secondary Guardian Phone', locale),
    name: 'secondaryGuardianPhone',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Secondary Guardian Email', locale),
    name: 'secondaryGuardianEmail',
    isImportField: true,
    isSettingItem: true,
  },

]



// WEBPACK FOOTER //
// ./src/containers/pages/StudentSettings/basicInfoFields.js